/**
 * T243 — Depreciations API hooks.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../api';
import { depreciationKeys } from './keys';
import { useActiveTenantId } from '../../hooks/useTenantContext';

export interface DepreciationPlanDto {
  id: string;
  expenseId: string;
  tenantId: string;
  startDate: string;
  totalMonths: number;
  netAmount: string;
  monthlyRate: string;
  remainderMonthIndex: number;
  remainderAmount: string;
  status: 'active' | 'completed' | 'sonderafa';
  completedAt: string | null;
  sonderafaReason: string | null;
  cumulativeAmount: number;
  remainingAmount: number;
  monthsElapsed: number;
  version: number;
}

export function useDepreciations() {
  const tenantId = useActiveTenantId();
  return useQuery({
    queryKey: depreciationKeys.all(tenantId),
    queryFn: () =>
      api.get<{ items: DepreciationPlanDto[] }>('/depreciations'),
    enabled: tenantId !== null,
  });
}

export function useTriggerSonderAfA(planId: string) {
  const qc = useQueryClient();
  const tenantId = useActiveTenantId();
  return useMutation({
    mutationFn: (input: { reason: string; effectiveDate?: string }) =>
      api.post<DepreciationPlanDto>(`/depreciations/${planId}/sonder-afa`, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: depreciationKeys.all(tenantId) }),
  });
}
